import React, { Component, Fragment } from 'react';
import { Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Button  } from "reactstrap";
import {
  Product,
  User,
  ProductBundle,
  ProductGroup,
  ProductionPlanCategory,
  ProductType, Equipment,
  EquipmentType, Location,
  TestingMethod, Vendor, EmailListAdmin, Part,
  PartCategory,
  PartUnitOfMeasure,
  ProductUnitOfMeasure,
  WarehouseArea,
  COAIngredient,
  COAProduct,
  RequestedTestType,
  RequestedTestCategory,
} from "../components";
import {
  api
} from "../helpers";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const tabNames = {
  Products: 'products',
  ProductTypes: 'productTypes',
  ProductBundles: 'productBundles',
  ProductionPlanCategory: 'productionPlanCategory',
  ProductGroups: 'productGroup',
  Users: 'users',
  Equipment: 'equipment',
  EquipmentTypes: 'equipmentTypes',
  Locations: 'locations',
  TestingMethods: 'testingMethods',
  Vendors: 'vendors',
  VendorMechanics: 'vendorMechanics',
  EmailListAdmin: 'emailListAdmin',
  Parts: 'parts',
  PartCategories: 'partCategories',
  PartUnitOfMeasures: 'partsUnitOfMeasures',
  ProductUnitOfMeasures: 'productUnitOfMeasures',
  WarehouseArea: 'warehouseAreas',
  COAIngredients: "coaIngredients",
  COAProducts: "coaProducts",
  RequestedTestTypes: "requestedTestTypes",
  RequestedTestCategories: "requestedTestCategories"
};

export default class Admin extends Component {
  static displayName = Admin.name;
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.match && props.match.params && props.match.params.tab
        ? props.match.params.tab
        : props.currentUser.isAdministrator
          ? tabNames.Products : props.currentUser.isMaintenanceAdmin
            ? tabNames.Equipment : tabNames.Parts,
      changeCount: 0
    }
    this.toggleTab = this.toggleTab.bind(this);
    this.refreshAll = this.refreshAll.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  refreshAll() {
    this.setState({ changeCount: this.state.changeCount + 1 });
  }

  processCOA() {
    api.post("Public/ProcessCOA", { SharedApiKey: "1E4562BCD95A494AB68F6989060E43EA" })
      .then(r => r)
      .catch(error => console.log(error));
  }
  render() {
    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2"><Col><h4 className="">Admin</h4></Col></Row>
        <Row className="mt-2">
          <Col sm="3">
            <Nav tabs className="flex-column nav-pills">
              {this.props.currentUser.isAdministrator && (
                <Fragment>
                  <NavItem className={this.state.activeTab === tabNames.Products ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Products); }}>
                      <FontAwesomeIcon
                        icon="mortar-pestle"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Products
                      </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.ProductTypes ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.ProductTypes); }}>
                      <FontAwesomeIcon
                        icon="layer-group"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Product Types
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.ProductBundles ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.ProductBundles); }}>
                      <FontAwesomeIcon
                        icon="layer-group"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Product Bundles
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.ProductionPlanCategory ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.ProductionPlanCategory); }}>
                      <FontAwesomeIcon
                        icon="clipboard-list"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Production Plan Category
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.ProductGroups ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.ProductGroups); }}>
                      <FontAwesomeIcon
                        icon="th-list"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Product Groups
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.Users ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Users); }}>
                      <FontAwesomeIcon
                        icon="user-alt"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Users
                     </NavLink>
                  </NavItem>
                  <NavItem className="selected-tab"><NavLink></NavLink></NavItem>
                  <NavItem className={this.state.activeTab === tabNames.COAProducts ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.COAProducts); }}>
                      <FontAwesomeIcon
                        icon="sitemap"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      COA Products
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.COAIngredients ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.COAIngredients); }}>
                      <FontAwesomeIcon
                        icon="sitemap"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      COA Ingredients
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.RequestedTestTypes ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.RequestedTestTypes); }}>
                      <FontAwesomeIcon
                        icon="clipboard-list"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Requested Test Types
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.RequestedTestCategories ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.RequestedTestCategories); }}>
                      <FontAwesomeIcon
                        icon="clipboard-list"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Requested Test Categories
                     </NavLink>
                  </NavItem>
                  <NavItem className="selected-tab"><NavLink></NavLink></NavItem>
                </Fragment>
              )}
              {this.props.currentUser.isMaintenanceAdmin && (
                <Fragment>
                  <NavItem className={this.state.activeTab === tabNames.Equipment ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Equipment); }}>
                      <FontAwesomeIcon
                        icon="dolly-flatbed"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Equipment
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.EquipmentTypes ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.EquipmentTypes); }}>
                      <FontAwesomeIcon
                        icon="dolly-flatbed"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Equipment Types
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.Locations ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Locations); }}>
                      <FontAwesomeIcon
                        icon="map-marker-alt"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Locations
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.TestingMethods ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.TestingMethods); }}>
                      <FontAwesomeIcon
                        icon="tachometer-alt"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Testing Methods
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.Vendors ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Vendors); }}>
                      <FontAwesomeIcon
                        icon="people-carry"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Vendors
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.EmailListAdmin ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.EmailListAdmin); }}>
                      <FontAwesomeIcon
                        icon="envelope"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Manage Email List
                     </NavLink>
                  </NavItem>
                  <NavItem className="selected-tab"><NavLink></NavLink></NavItem>
                </Fragment>
              )}
              {!window.TurnOffCycleCount && this.props.currentUser.isWarehouseAdmin && (
                <Fragment>
                  <NavItem className={this.state.activeTab === tabNames.Parts ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.Parts); }}>
                      <FontAwesomeIcon
                        icon="cogs"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Parts
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.PartCategories ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.PartCategories); }}>
                      <FontAwesomeIcon
                        icon="cogs"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Part Categories
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.PartUnitOfMeasures ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.PartUnitOfMeasures); }}>
                      <FontAwesomeIcon
                        icon="cogs"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Part Unit of Measures
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.ProductUnitOfMeasures ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.ProductUnitOfMeasures); }}>
                      <FontAwesomeIcon
                        icon="cogs"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Product Unit of Measures
                     </NavLink>
                  </NavItem>
                  <NavItem className={this.state.activeTab === tabNames.WarehouseArea ? "selected-tab" : "cursor"}>
                    <NavLink onClick={() => { this.toggleTab(tabNames.WarehouseArea); }}>
                      <FontAwesomeIcon
                        icon="cogs"
                        className="ml-1 mt-0 mb-0 mr-2 pointer"
                      />
                      Warehouse Area
                     </NavLink>
                  </NavItem>
                </Fragment>)
              }
            </Nav>
          </Col>
          <Col sm="9" className="p-2">
            <TabContent activeTab={this.state.activeTab} className="mt-2">
              <TabPane tabId={tabNames.Products}>
                {this.state.activeTab === tabNames.Products &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <Product refreshAll={this.refreshAll} changeCount={this.state.changeCount}/>
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.ProductTypes}>
                {this.state.activeTab === tabNames.ProductTypes &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <ProductType refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>

              <TabPane tabId={tabNames.ProductBundles}>
                {this.state.activeTab === tabNames.ProductBundles &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <ProductBundle refreshAll={this.refreshAll} changeCount={this.state.changeCount}/>
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.ProductionPlanCategory}>
                {this.state.activeTab === tabNames.ProductionPlanCategory &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <ProductionPlanCategory refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.ProductGroups}>
                {this.state.activeTab === tabNames.ProductGroups &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <ProductGroup refreshAll={this.refreshAll} changeCount={this.state.changeCount}/>
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.Users}>
                {this.state.activeTab === tabNames.Users &&
                  <Row className="mb-0">
                    <Col sm="12">
                    <User refreshAll={this.refreshAll} changeCount={this.state.changeCount} currentUser={this.props.currentUser} impersonating={this.props.impersonating} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.Equipment}>
                {this.state.activeTab === tabNames.Equipment &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <Equipment refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.EquipmentTypes}>
                {this.state.activeTab === tabNames.EquipmentTypes &&
                  <Row className="mb-0">
                    <Col sm="12">
                    <EquipmentType refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.Locations}>
                {this.state.activeTab === tabNames.Locations &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <Location refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.TestingMethods}>
                {this.state.activeTab === tabNames.TestingMethods &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <TestingMethod refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.Vendors}>
                {this.state.activeTab === tabNames.Vendors &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <Vendor refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.EmailListAdmin}>
                {this.state.activeTab === tabNames.EmailListAdmin &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <EmailListAdmin refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.Parts}>
                {this.state.activeTab === tabNames.Parts &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <Part refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.PartCategories}>
                {this.state.activeTab === tabNames.PartCategories &&
                  <Row className="mb-0">
                    <Col sm="12">
                    <PartCategory refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.PartUnitOfMeasures}>
                {this.state.activeTab === tabNames.PartUnitOfMeasures &&
                  <Row className="mb-0">
                    <Col sm="12">
                    <PartUnitOfMeasure refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.ProductUnitOfMeasures}>
                {this.state.activeTab === tabNames.ProductUnitOfMeasures &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <ProductUnitOfMeasure refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.WarehouseArea}>
                {this.state.activeTab === tabNames.WarehouseArea &&
                  <Row className="mb-0">
                    <Col sm="12">
                    <WarehouseArea refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.COAProducts}>
                {this.state.activeTab === tabNames.COAProducts &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <COAProduct refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.COAIngredients}>
                {this.state.activeTab === tabNames.COAIngredients &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <COAIngredient refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.RequestedTestTypes}>
                {this.state.activeTab === tabNames.RequestedTestTypes &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <RequestedTestType refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
              <TabPane tabId={tabNames.RequestedTestCategories}>
                {this.state.activeTab === tabNames.RequestedTestCategories &&
                  <Row className="mb-0">
                    <Col sm="12">
                      <RequestedTestCategory refreshAll={this.refreshAll} changeCount={this.state.changeCount} />
                    </Col>
                  </Row>
                }
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin.js